type FileExtensions = 'txt' | 'pdf' | 'docx' | 'xlsx' | 'jpg' | 'png' | 'zip' | 'xml' | 'xlsx';
type FileWithExtension = `${string}.${FileExtensions}`;

const createFileNameWithExtension = (
  filename: string,
  fileType: FileExtensions,
): FileWithExtension => `${filename}.${fileType}`;

const createAnchorElement = (downloableUrl: string, filenameWithExtension: FileWithExtension) => {
  const a = document.createElement('a');
  a.style.display = 'none';
  document.body.appendChild(a);
  a.href = downloableUrl;
  a.download = filenameWithExtension;
  return a;
};

const downloadFile = (a: HTMLAnchorElement) => {
  a.click();
};

const doWindowCleanup = (a: HTMLAnchorElement, downloableUrl: string) => {
  a.remove();
  window.URL.revokeObjectURL(downloableUrl);
};

const downloadFileFromBlobResponse = (
  blob: Blob,
  fileName = 'filename',
  fileType: FileExtensions = 'pdf',
) => {
  const downloableUrl = window.URL.createObjectURL(blob);
  const filenameWithExtension = createFileNameWithExtension(fileName, fileType);
  const anchorElement = createAnchorElement(downloableUrl, filenameWithExtension);
  downloadFile(anchorElement);
  doWindowCleanup(anchorElement, downloableUrl);
};

export default downloadFileFromBlobResponse;
